module.exports = __webpack_public_path__ + "img/pr-13.1d1c66e2.png";